import React, { useState } from "react";

import { Box, Container, DropdownItem } from "./styles";

//Help Functions
import { openModal } from "../../helpers/modalFunctions"

//Interfaces
import { DropdownButtonPropsInterface } from "./interfaces";

//Assets
import more from "../../assets/icons/more.svg";


const DropdownButton = (props: DropdownButtonPropsInterface) => {
    const [ show, setShow ] = useState(false);

    const openViewForm = () => {
        if(props.setIsViewFormVisible !== undefined){
            if(props.selectedUser && props.setSelectedUser){
                props.setSelectedUser(props.selectedUser);
            }
            props.setIsViewFormVisible(true);
        } else if(props.isViewOptionVisible === true){
            if(props.selectedUser && props.setSelectedUser){
                props.setSelectedUser(props.selectedUser);
            }
        }
    }

    const openEditForm = (id: string) => {
        if(props.setIsEditFormVisible){
            if(props.selectedUser && props.setSelectedUser){
                props.setSelectedUser(props.selectedUser);
            }
            
            props.setIsEditFormVisible(id);
        }
    }

    const openEditFormSecondary = () => {
        if(props.setIsEditFormSecondaryVisible){
            if(props.selectedUser && props.setSelectedUser){
                props.setSelectedUser(props.selectedUser);
            }
            props.setIsEditFormSecondaryVisible("open");
        }
    }

    const openAddVarForm = () => {
        if(props.setIsAddVarFormVisible){
            if(props.selectedUser && props.setSelectedUser){
                props.setSelectedUser(props.selectedUser);
            }
            props.setIsAddVarFormVisible("open");
        }
    }

    const openAddImageForm = () => {
        if(props.setIsAddImageVisible){
            if(props.selectedUser && props.setSelectedUser){
                props.setSelectedUser(props.selectedUser);
            }
            props.setIsAddImageVisible("open");
        }
    }

    const isAddImageVisible = () => {
        if(props.isAddImageOptionVisible){
            return <DropdownItem className="dropdown-item" onClick={() => openAddImageForm()}>Adicionar Imagem</DropdownItem>
        }
    }

    const isViewItemVisible = () => {
        if(props.isViewOptionVisible){
            return <DropdownItem id={`${props.id}-option-view`} className="dropdown-item" data-toggle={props.openModal ? "modal" : ""} data-target={props.openModal ? props.modalId : ""} onClick={() => openViewForm()}>Visualizar</DropdownItem>
        }
    }

    const isGenLinkVisible = () => {
        if(props.isGenLinkTokenCardVisible){
                return <DropdownItem id={"generate-option-view"} className="dropdown-item"
                onClick={() => {
                    if(props.selectedUser && props.setGenerateLink && props.setSelectedUser){
                        props.setGenerateLink(props.selectedUser)
                    }
                }}>Adicionar novo cartão</DropdownItem>
        }
    }

    const isDisassociateOptionVisible = () => {
        if(props.isDisassociateOptionVisible){
            return <DropdownItem 
                className="dropdown-item" 
                onClick={() => {
                    if(props.selectedUser && props.setSelectedUser){
                        props.setSelectedUser(props.selectedUser.pl_planBranchIdAdquirente)
                    }
                    
                    if(props.setDisassociate) {
                        props.setDisassociate(true)
                    }
                }}
                    
            >Desassociar</DropdownItem>
        }
    }

    const isEditItemVisible = () => {
        if(props.isEditOptionVisible){
            return <DropdownItem className="dropdown-item" onClick={() => openEditForm(props.selectedUser ? props.selectedUser : "")}>Editar</DropdownItem>
        }
    }

    const isEditSecondaryItemVisible = () => {
        if(props.isEditSecondaryOptionVisible){
            return <DropdownItem className="dropdown-item" onClick={() => openEditFormSecondary()}>Editar variações</DropdownItem>
        }
    }

    const isAddVarItemVisible = () => {
        if(props.isAddVarVisible){
            return <DropdownItem className="dropdown-item" onClick={() => openAddVarForm()}>Adicionar variação</DropdownItem>
        }
    }
    

    const isRemoveItemVisible = () => {
        if(props.isRemoveOPtionVisible){
            return <DropdownItem className="dropdown-item" onClick={() => {props.removeFunction!(props.selectedUser.id)}} >Excluir</DropdownItem>
        }
    }

    const isSubscriptionOptions = () => {
        if(props.isSubscription){
            if(props.subscriptionStatus === "active"){
                return <DropdownItem className="dropdown-item" onClick={() => {
                    if(props.suspendSubscription){
                        props.suspendSubscription(props.selectedUser);
                    }
                }}>Suspender</DropdownItem>
            }else{
                return <DropdownItem className="dropdown-item" onClick={() => {
                    if(props.reactiveSubscription){
                        props.reactiveSubscription(props.selectedUser);
                    }
                }}>Reativar</DropdownItem>
            }
        }
    }

    const dropdownForTutorial = () => {
        return (
            <>
                <img src={more} id={`dropdownMenuButton-${props.id}`} onClick={() => setShow(!show)} />
                { show && <Box id={`dropdown-menu-${props.id}`}>
                    {isViewItemVisible()}
                    {isEditItemVisible()}
                    { props.children }
                    {isRemoveItemVisible()}
                    {isSubscriptionOptions()}
                    {isDisassociateOptionVisible()}
                    {isGenLinkVisible()}
                    {isEditSecondaryItemVisible()}
                    {isAddImageVisible()}
                    {isAddVarItemVisible()}

                </Box> }
            </>
        )
    }

    const dropdown = () => {
        return (
            <>
                <img src={more} id={`dropdownMenuButton-${props.id}`} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <div id={`dropdown-menu-${props.id}`} className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        {isViewItemVisible()}
                        {isEditItemVisible()}
                        { props.children }
                        {isEditSecondaryItemVisible()}

                        {isRemoveItemVisible()}
                        {isSubscriptionOptions()}
                        {isDisassociateOptionVisible()}
                        {isGenLinkVisible()}
                        {isAddImageVisible()}
                        {isAddVarItemVisible()}
                    </div>
            </>
        )
    }

    return(
        <Container className="dropleft" id={props.id}>
            
            { props.isTutorialOpen
                ? dropdownForTutorial()
                : dropdown()
            }
        </Container>
    )
}

export default DropdownButton;